import methodAPI from "./methodAPI";

export const melhorEnvioAPI = {
    gerarEtiqueta: async (orderId) => {
        return await methodAPI.post(`/orders/${orderId}/gerar-etiqueta`);
    }
}